
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M91 44.6c-16.6 4.5-30.5 15-38.8 29.4-6.9 11.8-9.7 34.6-8.9 72 .6 27.8 2.3 42.6 7.8 66.9 19.5 85.4 73.7 160.9 149.2 207.5 37.4 23.1 80.4 38.7 126.2 45.6 31.2 4.8 85 3.5 102.6-2.5 16.8-5.6 29.5-18.5 36.8-37.3l2.6-6.7V379c0-39.1-.1-40.7-2.2-47.5-4.5-14.3-15.5-28.1-28.3-35.7-4.3-2.5-19-7.9-45.7-16.9-32.9-10.9-40.8-13.2-47.1-13.6-14-.9-27.9 4-38.5 13.7-6.7 6.1-10.9 12.4-14.2 21.5-3.1 8.7-5.3 11-10.5 11-4 0-4.7-.7-42.7-38.8-38.1-38-38.8-38.7-38.8-42.7 0-5.2 2.3-7.4 11-10.5 17.6-6.4 29.8-20.1 34.1-38.2 3.1-13 2.1-17.6-12.5-61.6-9-26.7-14.4-41.4-16.9-45.7-7.4-12.5-21.1-23.5-35.2-28.3-6.2-2-8.3-2.2-45.5-2.4-32-.2-40 0-44.5 1.3M165.8 86c5.5 1.2 11.4 5.6 13.9 10.3 2.9 5.6 24.3 71.1 24.3 74.3 0 4.6-2.6 7.1-10.4 9.9-9.5 3.5-14.8 6.7-21 13-9.6 9.8-14.6 22.2-14.6 36.4 0 10.2 1.6 16.6 6.1 25.2 2.8 5.4 9.6 12.8 44.8 48s42.6 42 48 44.8c8.6 4.5 15 6.1 25.2 6.1 14.2 0 26.6-5 36.4-14.6 6.3-6.2 9.5-11.5 13-21 2.8-7.8 5.3-10.4 9.9-10.4 3.2 0 68.7 21.4 74.3 24.3 4.7 2.5 9.1 8.4 10.3 13.9 1.2 6 1.3 58.8 0 64.2-1.6 7.2-6.9 12.3-14.3 13.7-2.4.4-12.1 1.3-21.4 1.9-18.3 1.3-40.6.3-59.6-2.5C212 405.6 116.4 315.6 91.6 198.3c-6.5-30.7-7.9-66.2-4-96.6 1.1-7.8 6.4-14 13.5-15.7 5.1-1.2 59-1.2 64.7 0"}})])
          )
        }
      }
    